import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const fmt = (d) => { try { return new Date(d).toLocaleDateString("nl-BE"); } catch { return d; } };

export default function Submissions() {
  const [tab, setTab] = useState("members");
  const [members, setMembers] = useState([]);
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    api.get("/admin/members").then((r) => setMembers(r.data)).catch(() => {});
    api.get("/admin/contacts").then((r) => setContacts(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-submissions">
      <h1 className="font-serif text-4xl text-[#0A3087] mb-6">Inzendingen</h1>
      <div className="flex gap-2 mb-6">
        {[["members", `Lidmaatschap (${members.length})`], ["contacts", `Contact (${contacts.length})`]].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`sub-tab-${k}`} className={`px-4 py-2 rounded-md text-sm font-500 transition-colors ${tab === k ? "text-white" : "bg-white border border-[#E2E8F0] text-[#0B0B0C]/70"}`} style={tab === k ? { background: "var(--elsa-blue)" } : {}}>
            {l}
          </button>
        ))}
      </div>

      <div className="bg-white border border-[#E2E8F0] rounded-lg overflow-hidden">
        {tab === "members" ? (
          <table className="w-full text-sm">
            <thead><tr className="bg-[#F4F5F7] text-left text-[#0B0B0C]/60">
              <th className="px-5 py-3 font-500">Naam</th><th className="px-5 py-3 font-500">E-mail</th><th className="px-5 py-3 font-500">Universiteit</th><th className="px-5 py-3 font-500">Jaar</th><th className="px-5 py-3 font-500">Datum</th>
            </tr></thead>
            <tbody>
              {members.map((m) => (
                <tr key={m.id} className="border-t border-[#E2E8F0]">
                  <td className="px-5 py-4">{m.first_name} {m.last_name}</td>
                  <td className="px-5 py-4">{m.email}</td>
                  <td className="px-5 py-4">{m.university}</td>
                  <td className="px-5 py-4">{m.study_year}</td>
                  <td className="px-5 py-4">{fmt(m.created_at)}</td>
                </tr>
              ))}
              {members.length === 0 && <tr><td colSpan={5} className="px-5 py-10 text-center text-[#0B0B0C]/40">Nog geen aanvragen.</td></tr>}
            </tbody>
          </table>
        ) : (
          <table className="w-full text-sm">
            <thead><tr className="bg-[#F4F5F7] text-left text-[#0B0B0C]/60">
              <th className="px-5 py-3 font-500">Naam</th><th className="px-5 py-3 font-500">E-mail</th><th className="px-5 py-3 font-500">Onderwerp</th><th className="px-5 py-3 font-500">Bericht</th><th className="px-5 py-3 font-500">Datum</th>
            </tr></thead>
            <tbody>
              {contacts.map((c) => (
                <tr key={c.id} className="border-t border-[#E2E8F0]">
                  <td className="px-5 py-4">{c.name}</td>
                  <td className="px-5 py-4">{c.email}</td>
                  <td className="px-5 py-4">{c.subject}</td>
                  <td className="px-5 py-4 max-w-xs truncate">{c.message}</td>
                  <td className="px-5 py-4">{fmt(c.created_at)}</td>
                </tr>
              ))}
              {contacts.length === 0 && <tr><td colSpan={5} className="px-5 py-10 text-center text-[#0B0B0C]/40">Nog geen berichten.</td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
